import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faPlaceOfWorship } from "@fortawesome/free-solid-svg-icons";

const iglesiasCol1 = [
  {
    nombre: "Iglesia de Dios",
    link: "https://maps.app.goo.gl/kmNgCoEgLVgKiyWu7",
    direccion: "Progreso 30.",
  },
  {
    nombre: "Iglesia Casa de Oración",
    link: "https://maps.app.goo.gl/3237mGBP9wo9wRZK6",
    direccion: "San Lorenzo 481.",
  },
  {
    nombre: "Iglesia Misión Cristiana a Canaan",
    link: "https://maps.app.goo.gl/Vqu91w7fNthxS6su9",
    direccion: "Bv. Rodolfo Moyano 678.",
  },
  {
    nombre: "Iglesia Ministerio Poder de la Oración",
    link: "https://maps.app.goo.gl/75vRqgpmDFnNfFsx9",
    direccion: "Francia 110.",
  },
  {
    nombre: "Iglesia Alianza Pastoral Cristiana",
    link: "https://maps.app.goo.gl/DTq4XeBHN3myb8Pg6",
    direccion: "Bartolomé Mitre 1125.",
  },
];

const iglesiasCol2 = [
  {
    nombre: "Centro Familiar Cristiano",
    link: "https://maps.app.goo.gl/KkPY3iLruMzQ6fcR6",
    direccion: "Bv. Rodolfo Moyano & Turquia.",
  },
  {
    nombre: "Asamblea de Dios",
    link: "https://maps.app.goo.gl/Au51TEH2ikNU7X6L8",
    direccion: "Rio Negro 568.",
  },
  {
    nombre: "Cita con la Vida",
    link: "https://maps.app.goo.gl/3BGYHKgxvrgimDUQ6",
    direccion: "Leandro N. Alem 282.",
  },
  {
    nombre: "Comunidad Cristiana Oliva",
    link: "https://maps.app.goo.gl/o6jfD3UVe73a94Hq8",
    direccion: "Hypólito Yrigoyen 375.",
  },
  {
    nombre: "Iglesia Misionera de Poder",
    link: "https://maps.app.goo.gl/iYpHMyLpDBoWLHSp7",
    direccion: "Esquina hipólito Yrigoyen y Paula Albarracín.",
  },
];

const IglesiasEvangelicas = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon
            icon={faPlaceOfWorship}
            style={{ color: "#c0392b", marginRight: 8 }}
          />
          Iglesias Evangelicas
        </h5>
        <ul className="lista-referencias">
          {iglesiasCol1.map((iglesia, i) => (
            <li key={i}>
              <FontAwesomeIcon
                icon={faMapLocationDot}
                style={{ marginRight: 8 }}
              />
              <a href={iglesia.link} target="_blank" rel="noopener noreferrer">
                {iglesia.nombre}
              </a>
              <div className="ms-2 me-auto">{iglesia.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-6">
        <ul className="lista-referencias">
          {iglesiasCol2.map((iglesia, i) => (
            <li key={i}>
              <FontAwesomeIcon
                icon={faMapLocationDot}
                style={{ marginRight: 8 }}
              />
              <a href={iglesia.link} target="_blank" rel="noopener noreferrer">
                {iglesia.nombre}
              </a>
              <div className="ms-2 me-auto">{iglesia.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default IglesiasEvangelicas;
